<template>
  <div class="mx-auto mt-5">
    <v-row class="mx-auto" align="center" v-for="item in items" :key="item.tuc">
      <v-col cols="12" class="py-0 d-flex justify-space-between">
        <h3>Especificações TUC {{ item.tuc }}</h3>
        <div v-if="item.dados != ''">
          <v-btn 
          elevation="1" 
          :loading="loadingRelatorioPdf" 
          small dark text 
          color="primary" 
          @click="relatorioPDF(item.tuc)">
            <v-icon small>mdi-file-find-outline</v-icon> Visualizar PDF
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12">
        <v-data-table 
        dense 
        :headers="headers" 
        :items="item.dados" 
        :items-per-page="5" 
        no-data-text="Não há dados." mobile-breakpoint="800"
        :headerProps="{
          sortByText: 'Ordenar Por',
         }" 
        :footer-props="{
          'items-per-page-options': [5, 10, 20, -1],
          'items-per-page-all-text': 'Tudo',
          'items-per-page-text': 'Itens por página',
        }" 
          >
          <template 
          v-slot:[`item.somatorio`]="{ item }">{{
              item["somatorio"] | parseNumberToDecimalBR
          }}</template>
          <template 
          v-slot:[`item.media`]="{ item }">{{
              item["media"] | parseNumberToDecimalBR
          }}</template>
          <template 
          v-slot:[`item.desvio_padrao`]="{ item }">{{
              item["desvio_padrao"] | parseNumberToDecimalBR
          }}</template>
          <template 
          v-slot:[`item.maximo`]="{ item }">{{
              item["maximo"] | parseNumberToDecimalBR
          }}</template>
          <template 
          v-slot:[`item.1_quartil`]="{ item }">{{
              item["1_quartil"] | parseNumberToDecimalBR
          }}</template>
          <template 
          v-slot:[`item.2_quartil`]="{ item }">{{
              item["2_quartil"] | parseNumberToDecimalBR
          }}</template>
          <template 
          v-slot:[`item.3_quartil`]="{ item }">{{
              item["3_quartil"] | parseNumberToDecimalBR
          }}</template>
          <template 
          v-slot:[`item.minimo`]="{ item }">{{
              item["minimo"] | parseNumberToDecimalBR
          }}</template>
        </v-data-table>
      </v-col>
    </v-row>
    <relatorio-pdf 
    :dados="dados" 
    ref="relatorioPDF" 
    @closeLoading="closeLoading()"
    />
  </div>
</template>

<script>

import More from "highcharts/highcharts-more";
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
import HighchartsExporting from "highcharts/modules/exporting.js";
HighchartsNoData(Highcharts);
More(Highcharts);
HighchartsExporting(Highcharts);

export default {
  name: "AnaliticoVariacoesPrecoUnitario",

  components: {
    RelatorioPdf: () =>
      import("@/components/variacoesPrecoUnitario/RelatorioPdf.vue"),
  },

  props: {
    dados: {
      type: Array,
      required: true,
    },
    tucsDisponiveis: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      loadingRelatorioPdf: false,
      headers: [
        {
          text: "TUC",
          value: "TUC",
        },
        {
          text: "Cód. Material",
          value: `CodMaterial`,
        },
        {
          text: "QTD Total",
          value: `somatorio`,
        },
        {
          text: "Média",
          value: `media`,
        },
        {
          text: "DP",
          value: `desvio_padrao`,
        },
        {
          text: "Máximo",
          value: `maximo`,
        },
        {
          text: "Q3",
          value: `3_quartil`,
        },
        {
          text: "Q2",
          value: `2_quartil`,
        },
        {
          text: "Q1",
          value: `1_quartil`,
        },
        {
          text: "Mínimo",
          value: `minimo`,
        },
      ],
    };
  },

  computed: {
    items() {
      if (!this.tucsDisponiveis) return [];

      let items = [];

      this.tucsDisponiveis.forEach((tuc) => {
        items.push({
          tuc: tuc,
          dados: this.dados.filter((dado) => dado.TUC === tuc),
        });
      });

      return items;
    },
  },
  methods: {
    relatorioPDF(tuc) {
      this.loadingRelatorioPdf = true;

      setTimeout(() => { 
        this.$refs.relatorioPDF.gerarRelatorioPDF(tuc);
       }, 1000);

    },
    closeLoading(){
      this.loadingRelatorioPdf = false
    }
  }
};
</script>
